import {faker} from '@faker-js/faker';

export const getUserProfileLink = () => {
  return `/user/${faker.person.firstName()}`
}

export const getCategoryLink = (categoryId) => {
  return `/category/${categoryId || faker.person.department()}`
}

export const getHashtagLink = (id) => {
  return `/hashtag/${id || faker.person.department()}`
}

export const getFilteredPollsLink = (id) => {
  return `/filters/${id || faker.person.department()}`
}

export const getHastags = () => {
  const hashtags = []
  for (let i = 0; i < 100; i++) {
    hashtags.push(faker.commerce.product())
  }
  return hashtags
}

export const getRankUpOrDown = () => {
  return faker.number.int({min: 1, max: 15})
}

export const getRandomBoolean = () => {
  return faker.datatype.boolean(0.5)
}

export const getRandomCoins = () => {
  return faker.number.int({min: 100, max: 1000})
}

export const getRating = () => Math.round(faker.number.float({min: 2, max: 5}) * 10) / 10
export const getNumberOfRating = () => faker.number.int({min: 10, max: 1000})
export const noop = () => {
}
